import Modal from '@shared/innmaxUI/Modal'
import Tabs from '@shared/Tabs'
import { ModalProps } from 'antd/lib/modal'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ModalBody } from 'src/components/Modal'
import styled from 'styled-components'
import Marker from './Marker'

interface Props extends ModalProps {
  visible: boolean
  onCancel: (evt: React.MouseEvent<HTMLElement>) => void
}

function MarkerModal({ visible, onCancel, ...props }: Props) {
  const { t } = useTranslation()

  return (
    <StyledModal
      open={visible}
      width={960}
      className="form-item--is-no-margin-bottom"
      title={t('dashboard:marker explanation')}
      onCancel={onCancel}
      bodyStyle={{
        padding: 0,
      }}
      footer={false}
      {...props}>
      <StyledModalBody style={{ height: '620px' }}>
        <Tabs
          items={[
            {
              key: 'marker',
              label: '充電樁圖標',
              children: <Marker />,
            },
            // {
            //   key: 'device',
            //   label: t('dashboard:device marker explanation'),
            //   children: <Device />,
            // },
          ]}
        />
      </StyledModalBody>
    </StyledModal>
  )
}

const StyledModal = styled(Modal)`
  .ant-modal-footer > div {
    button {
      width: 80px;
      height: 32px;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 500;
      border: solid 1.3px ${({ theme }) => theme.primary};
      &:first-child {
        color: ${({ theme }) => theme.primary};
      }
      &:last-child {
        background-color: ${({ theme }) => theme.primary};
        color: #ffffff;
      }
    }
  }
`

const StyledModalBody = styled(ModalBody)`
  padding: 0 !important;

  form {
    display: flex;
    height: 100%;

    .ant-tabs-content.ant-tabs-content-top {
      height: 100%;
      overflow: auto;

      .ant-tabs-tabpane {
        height: 100%;
        padding-bottom: 15px;

        div {
          overflow: auto;
          min-height: 100%;
        }
      }
    }
  }
`

export default React.memo(MarkerModal)
